module.exports = [
    'décimo',
    'centésimo',
    'milésimo',
    'décimo de milésimo',
    'centésimo de milésimo',
    'milionésimo',
    'décimo de milionésimo',
    'centésimo de milionésimo',
    'bilionésimo',
    'décimo de bilionésimo',
    'centésimo de bilionésimo',
    'trilionésimo',
    'décimo de trilionésimo',
    'centésimo de trilionésimo',
    'quatrilionésimo',
    'décimo de quatrilionésimo',
    'centésimo de quatrilionésimo',
    'quintilionésimo',
    'décimo de quintilionésimo',
    'centésimo de quintilionésimo'
];
